export default function submitForm(
  event,
  selectedRegions = [],
  selectedAmenities = [],
  selectedCafeIds = [],
  selectedCategoryIds = [],
) {
  let status = '',
    name = '',
    amount = '',
    regionIds = '',
    cafeIds = '',
    hasEvent = '',
    isBest = '',
    hasDiscount = '',
    amenities = '',
    startDate = '',
    endDate = '',
    startPubish = '',
    endPublish = '',
    otherFields = '',
    suspended = '',
    responseType = '',
    cafeNamePart = '',
    cafeManagerNamePart = '',
    contractNumberPart = '',
    isExpireIn14Days = '',
    cityCode = '',
    checkoutStart = '',
    checkoutEnd = '',
    isCafeAllowedToRespond = '',
    tableNumber = '',
    fromTime = '',
    toTime = '',
    menuItemTitle = '',
    categoryIds = '',
    cafeType = '',
    cafeStatus = '',
    paymentStatus = '',
    type = '';

  let date, publisDate, checkoutAt;
  event.preventDefault();
  const el = [...event.currentTarget.elements]
    .filter(e => {
      if (e.type === 'radio' || e.type === 'checkbox') {
        if (e.checked) {
          return true;
        }
        return false;
      }
      if (e.name === 'resetButton') {
        return false;
      }
      if (e.name !== '') {
        return true;
      }
      return false;
    })
    .map(element => {
      if (element.type === 'checkbox') {
        return {
          name: element.name,
          value: element.value,
        };
      } else {
        return {
          name: element.name,
          value: element.value,
        };
      }
    });
  el.forEach(elem => {
    if (elem.value) {
      switch (elem.name) {
        case 'amenities':
          let commaSeparatedAmenities = selectedAmenities
            .map(amenity => amenity.value)
            .join(',');
          amenities = `amenities~contains~${commaSeparatedAmenities}`;
          break;
        case 'regionIds':
          let commaSeparatedRegions = selectedRegions
            .map(region => region.value)
            .join(',');
          regionIds = `regionIds~contains~${commaSeparatedRegions}`;
          break;
        case 'cafeIds':
          let commaSeparatedCafeIds = selectedCafeIds
            .map(cafe => cafe.value)
            .join(',');
          cafeIds = `cafeIds~contains~${commaSeparatedCafeIds}`;
          break;
        case 'name':
          name = `name~contains~${elem.value}`;
          break;
        case 'isBest':
          isBest = `isBest~eq~${elem.value}`;
          break;
        case 'hasDiscount':
          hasDiscount = `hasDiscount~eq~${elem.value}`;
          break;
        case 'hasEvent':
          hasEvent = `hasEvent~eq~${elem.value}`;
          break;
        case 'status':
          status = `status~eq~${elem.value}~or~${status}`;
          break;
        case 'startDate':
          startDate = `createdAt~gte~${elem.value}`;
          break;
        case 'endDate':
          endDate = `createdAt~lte~${elem.value}`;
          break;
        case 'startDate1':
          startDate = `createdDate~gte~${elem.value}`;
          break;
        case 'endDate1':
          endDate = `createdDate~lte~${elem.value}`;
          break;
        case 'fromDate':
          startDate = `date~gte~${elem.value}`;
          break;
        case 'toDate':
          endDate = `date~lte~${elem.value}`;
          break;
        case 'amount':
          amount = `amountPart~like~${elem.value}`;
          break;
        case 'startPublishedAtDate':
          startPubish = `publishedAt~gte~${elem.value}`;
          break;
        case 'endPublishedAtDate':
          endPublish = `publishedAt~lte~${elem.value}`;
          break;
        case 'suspended':
          suspended = `isSuspended~eq~${elem.value}`;
          break;
        case 'responseType':
          responseType = `responseType~eq~${elem.value}~or~${responseType}`;
          break;
        case 'isCafeAllowedToRespond':
          isCafeAllowedToRespond = `isCafeAllowedToRespond~eq~${elem.value}`;
          break;
        case 'cafeNamePart':
          cafeNamePart = `cafeNamePart~like~${elem.value}`;
          break;
        case 'checkoutStart':
          checkoutStart = `checkoutAt~gte~${elem.value}`;
          break;
        case 'checkoutEnd':
          checkoutEnd = `checkoutAt~lte~${elem.value}`;
          break;
        case 'cafeManagerNamePart':
          cafeManagerNamePart = `cafeManagerNamePart~like~${elem.value}`;
          break;
        case 'contractNumberPart':
          contractNumberPart = `contractNumberPart~like~${elem.value}`;
          break;
        case 'cityCode':
          cityCode = `cityCode~eq~${elem.value}`;
          break;
        case 'isExpireIn14Days':
          isExpireIn14Days = `isExpireIn14Days~eq~${elem.value}`;
          break;
        case 'tableNumber':
          tableNumber = `tableNumber~eq~${elem.value}`;
          break;
        case 'fromTime':
          fromTime = `fromTime~eq~${elem.value}`;
          break;
        case 'toTime':
          toTime = `toTime~eq~${elem.value}`;
        case 'categoryIds':
          let commaSeparatedCategoryIds = selectedCategoryIds
            .map(category => category.value)
            .join(',');
          categoryIds = `categoryIds~eq~${commaSeparatedCategoryIds}`;
          break;
        case 'menuItemTitle':
          menuItemTitle = `menuItemTitle~contains~${elem.value}`;
          break;
        case 'cafeType':
          cafeType = `cafeType~eq~${elem.value}`;
          break;
        case 'cafeStatus':
          cafeStatus = `cafeStatus~eq~${elem.value}~or~${cafeStatus}`;
          break;
        case 'paymentStatus':
          paymentStatus = `paymentStatus~eq~${elem.value}~or~${paymentStatus}`;
          break;
        case 'type':
          type = `type~contains~${elem.value}`;
          break;
        default:
          otherFields += `(${elem.name}~like~${elem.value})~and~`;
          break;
      }
    }
  });
  if (startDate && endDate) {
    date = `${startDate}~and~${endDate}`;
  } else if (startDate) {
    date = startDate;
  } else {
    date = endDate;
  }

  if (startPubish && endPublish) {
    publisDate = `${startPubish}~and~${endPublish}`;
  } else if (startPubish) {
    publisDate = startPubish;
  } else {
    publisDate = endPublish;
  }

  if (checkoutStart && checkoutEnd) {
    checkoutAt = `${checkoutStart}~and~${checkoutEnd}`;
  } else if (checkoutStart) {
    checkoutAt = checkoutStart;
  } else {
    checkoutAt = checkoutEnd;
  }

  let filter = `filter=${isBest && `(${isBest})~and~`}`;
  filter += `${hasDiscount && `(${hasDiscount})~and~`}`;
  filter += `${hasEvent && `(${hasEvent})~and~`}`;
  filter += `${status && `(${status.slice(0, -4)})~and~`}`;
  filter += `${responseType && `(${responseType.slice(0, -4)})~and~`}`;
  filter += `${date && `(${date})~and~`}`;
  filter += `${fromTime && `(${fromTime})~and~`}`;
  filter += `${toTime && `(${toTime})~and~`}`;
  filter += `${publisDate && `(${publisDate})~and~`}`;
  filter += `${regionIds && `(${regionIds})~and~`}`;
  filter += `${amenities && `(${amenities})~and~`}`;
  filter += `${cafeIds && `(${cafeIds})~and~`}`;
  filter += `${name && `(${name})~and~`}`;
  filter += `${suspended && `(${suspended})~and~`}`;
  filter += `${amount && `(${amount})~and~`}`;
  filter += `${cafeNamePart && `(${cafeNamePart})~and~`}`;
  filter += `${cafeManagerNamePart && `(${cafeManagerNamePart})~and~`}`;
  filter += `${contractNumberPart && `(${contractNumberPart})~and~`}`;
  filter += `${cityCode && `(${cityCode})~and~`}`;
  filter += `${isExpireIn14Days && `(${isExpireIn14Days})~and~`}`;
  filter += `${checkoutAt && `(${checkoutAt})~and~`}`;
  filter += `${isCafeAllowedToRespond && `(${isCafeAllowedToRespond})~and~`}`;
  filter += `${tableNumber && `(${tableNumber})~and~`}`;
  filter += `${menuItemTitle && `(${menuItemTitle})~and~`}`;
  filter += `${categoryIds && `(${categoryIds})~and~`}`;
  filter += `${cafeType && `(${cafeType})~and~`}`;
  filter += `${cafeStatus && `(${cafeStatus})~and~`}`;
  filter += `${paymentStatus && `(${paymentStatus})~and~`}`;
  filter += `${type && `(${type})~and~`}`;
  filter += `${otherFields && `${otherFields}`}`.replace(/\s\s+/g, '');

  filter = filter !== 'filter=' ? filter.slice(0, filter.length - 5) : '';

  return filter;
}
